/* VyomTara | Footer Categories — standalone custom element, no shared globals */
(function () {
  if (window.customElements && customElements.get('vt-footer-categories')) return;

  class VTFooterCategories extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode || 'mobile';
      this.bp = parseInt(this.dataset.breakpoint, 10) || 750;
      this.single = this.dataset.single === 'true';
      this.items = Array.prototype.slice.call(this.querySelectorAll('.vt-fc__item'));
      if (!this.items.length) return;

      this.addEventListener('click', this.onClick.bind(this));

      this.onResize = this.debounce(this.apply.bind(this), 150);
      window.addEventListener('resize', this.onResize, { passive: true });

      this.apply();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    debounce(fn, wait) {
      var t = null;
      return function () {
        if (t) clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }

    /* should every folder be forced open at this viewport width? */
    forcedOpen() {
      if (this.mode === 'never') return true;
      if (this.mode === 'mobile') return window.innerWidth > this.bp;
      return false;
    }

    /* a folder row can carry more than one toggle (the icon and, when the
       label is not a link, the label itself) — keep them all in step */
    togglesIn(item) {
      return Array.prototype.slice.call(item.querySelectorAll('[data-vt-fc-toggle]'));
    }

    setItem(item, open) {
      var panel = item.querySelector('[data-vt-fc-panel]');
      if (!panel) return;
      var btns = this.togglesIn(item);
      panel.hidden = !open;
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      item.classList.toggle('is-open', open);
    }

    apply() {
      var forced = this.forcedOpen();
      for (var i = 0; i < this.items.length; i++) {
        var it = this.items[i];
        if (!it.querySelector('[data-vt-fc-panel]')) continue; // link-only folder
        if (forced) {
          this.setItem(it, true);
          var btns = this.togglesIn(it);
          for (var j = 0; j < btns.length; j++) {
            btns[j].setAttribute('tabindex', this.mode === 'never' ? '-1' : '0');
          }
        } else if (!this.touched) {
          // first pass at collapsed widths: honour the per-block "start open" setting
          this.setItem(it, it.classList.contains('is-preopen'));
        }
      }
    }

    onClick(e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-vt-fc-toggle]') : null;
      if (!btn || !this.contains(btn)) return;
      if (this.forcedOpen()) return;

      e.preventDefault();
      this.touched = true;

      var item = btn.closest('.vt-fc__item');
      if (!item || !item.querySelector('[data-vt-fc-panel]')) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';

      if (open && this.single) {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i] !== item) this.setItem(this.items[i], false);
        }
      }

      this.setItem(item, open);
    }
  }

  customElements.define('vt-footer-categories', VTFooterCategories);
})();